export const COLOR_TYPES = {
  NON_STANDARD: 'Non-Standard',
  STANDARD: 'Standard'
};
